import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { accent } from '@/components/feature/solution/theme';

interface ProductItem {
  icon: string;
  name: string;
  en: string;
  desc: string;
  tags: string[];
  href: string;
}

interface ProductData {
  eyebrow: string;
  title: string;
  lead: string;
  items: ProductItem[];
}

export default function LogisticsProducts({ data }: { data: ProductData }) {
  const a = accent('green');

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex justify-center">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-semibold tracking-wide whitespace-nowrap">
            <i className="ri-apps-2-line"></i>
            {data.eyebrow}
          </span>
        </div>
        <div className="mt-4">
          <SectionHeading title={data.title} subtitle={data.lead} />
        </div>

        <div data-product-shop className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {data.items.map((p, idx) => (
            <Reveal key={p.name} delay={idx * 60}>
              <Link
                to={p.href}
                className="group flex h-full flex-col rounded-2xl border border-background-200 bg-background-50 p-6 cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:border-accent-300"
              >
                <div className="flex items-start gap-4">
                  <span className={`w-12 h-12 shrink-0 flex items-center justify-center rounded-xl ${a.iconBox}`}>
                    <i className={`${p.icon} text-2xl`}></i>
                  </span>
                  <div className="min-w-0">
                    <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 leading-snug">
                      {p.name}
                    </h3>
                    <div className="text-xs text-foreground-500 mt-0.5">{p.en}</div>
                  </div>
                </div>

                <p className="mt-4 text-sm text-foreground-700 leading-relaxed">{p.desc}</p>

                <div className="mt-4 flex flex-wrap gap-1.5">
                  {p.tags.map((t) => (
                    <span
                      key={t}
                      className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs whitespace-nowrap"
                    >
                      {t}
                    </span>
                  ))}
                </div>

                <span className="mt-5 inline-flex items-center gap-1 text-xs font-medium text-accent-700 transition-transform duration-300 group-hover:translate-x-0.5">
                  查看产品
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}